import GoalError from './GoalError';
class GoalDoesNotBelongToTheInvestor extends GoalError {
    constructor(options) {
        super('The goal does not belong to the investor.', options);
    }
}
export default GoalDoesNotBelongToTheInvestor;
